import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import BtnLoader from "./BtnLoader"; // Component for loading animation
import { FORGOTPASSWORD_API } from "../app/constants";
import { BASE_URL } from "..";
import { useForm } from "react-hook-form";
import Notification from "../helper/Notification";

const ForgotPasswordSection = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange", // Ensures validation on change
  });

  const [isLoading, setIsLoading] = useState(false); // Track loading state
  const [isMessage, setIsMessage] = useState(null); // Stores message for notification
  const [showNotification, setShowNotification] = useState(false); // Toggle notification visibility
  const navigate = useNavigate();

  const handleBtnLoader = async (data) => {
    const { phoneNumber } = data;

    if (!phoneNumber) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await axios.post(`${BASE_URL}${FORGOTPASSWORD_API}`, {
        phoneNumber,
      });

      if (response.status === 200 && response.data.code === 1) {
        sessionStorage.setItem("otpflow", true);
        sessionStorage.setItem("phoneNumber", phoneNumber);
        sessionStorage.setItem("userId", response.data.data.id);
        sessionStorage.setItem("msg1", response.data.message);

        setIsMessage(response.data.message);
        setShowNotification(true);
        navigate("/otp-verification");
      } else {
        setIsMessage(response.data.message);
        setShowNotification(true);
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || "Failed to send OTP. Please try again.";
      setIsMessage(errorMessage);
      setShowNotification(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="flex-center bg-light">
      <Notification
        show={showNotification}
        type="success"
        title="User Not Found"
        message={isMessage}
        onClose={() => setShowNotification(false)}
      />

      <div className="container container-lg flex-center bg-white py-40">
        <div className="gy-4 rounded bg-white d-flex flex-column flex-lg-row gap-10">
          {/* Left Side Section */}
          <div
            className="col-xl-6 p-0 order-lg-1 order-2 flex-center flex-column mt-0"
            style={{
              maxWidth: "26rem",
              minHeight: "33rem",
              background:
                "linear-gradient(to bottom, #FE5014, #FE5014, #FD9B7B, #FFC6C6)",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <h4 className="text-capitalize text-white p-20 pt-40">
              Shopping with lowest prices & maximum discounts
            </h4>
            <p className="text-white px-20">
              We are connected with wholesalers to offer the best price on every
              item you buy
            </p>
            <img
              className="mt-40"
              src="assets/images/icon/login-img.png"
              alt="LoginImg"
              style={{ objectFit: "cover" }}
            />
          </div>

          {/* Right Side Section */}
          <div
            className="card d-flex justify-content-center p-24 order-lg-2 order-1 border-0"
            style={{ maxWidth: "23rem", width: "100%" }}
          >
            <div className="flex-center flex-column mb-24">
              <img
                style={{ width: "10rem" }}
                src="assets/images/logo/header_logo.png"
                alt="Logo"
              />
              <div>
                <p className="text-2xl fw-bolder text-black">
                  Verify your phone number
                </p>
                <p className="text-xs text-muted">
                  Enter your phone number to receive a verification code
                </p>
              </div>
            </div>

            <form onSubmit={handleSubmit(handleBtnLoader)}>
              <div className="d-flex align-items-center">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                >
                  <div className="flex-center">
                    <div className="text-nowrap px-10">+92</div>
                    <div
                      style={{
                        borderLeft: "1px solid #ccc",
                        height: "20px",
                        marginLeft: "8px",
                      }}
                    ></div>
                  </div>
                  <input
                    type="text"
                    className="common-input text-sm border-0"
                    placeholder="Enter your phone number"
                    maxLength="10"
                    {...register("phoneNumber", {
                      required: "Phone number is required",
                      minLength: {
                        value: 10,
                        message: "Phone number must be exactly 10 digits",
                      },
                      pattern: {
                        value: /^3\d{9}$/,
                        message: "Invalid number entered",
                      },
                    })}
                  />
                </div>
              </div>
              {errors.phoneNumber && (
                <div className="text-danger text-xs my-2">
                  {errors.phoneNumber.message}
                </div>
              )}

              <div className="my-14 w-100">
                <button
                  type="submit"
                  className="w-100 btn py-18 px-40 rounded-0 shadow"
                  style={{ background: "#FE5014" }}
                  disabled={!isValid || isLoading}
                >
                  {isLoading ? <BtnLoader /> : "Send OTP"}
                </button>
              </div>
              <p className="text-xs text-muted py-40 px-10">
                We'll send a one-time password (OTP) to your phone number to
                verify it's you.
              </p>
            </form>

            <div className="w-100 flex-center gap-4">
              <p className="text-xs fw-normal text-muted">
                Already have an account?
              </p>
              <Link
                to="/login"
                className="text-xs fw-medium text-main text-decoration-underline hover-text-decoration-none"
              >
                Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPasswordSection;
